module.exports = __webpack_public_path__ + "img/bell-peppers-2708680.fe22e491.jpg";